import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _setPrototypeOf from "@babel/runtime/helpers/esm/setPrototypeOf";
const _excluded = ["transformations"];
function _wrapRegExp() {
  _wrapRegExp = function (e, r) {
    return new BabelRegExp(e, void 0, r);
  };
  var e = RegExp.prototype,
    r = new WeakMap();
  function BabelRegExp(e, t, p) {
    var o = new RegExp(e, t);
    return r.set(o, p || r.get(e)), _setPrototypeOf(o, BabelRegExp.prototype);
  }
  function buildGroups(e, t) {
    var p = r.get(t);
    return Object.keys(p).reduce(function (r, t) {
      var o = p[t];
      if ("number" == typeof o) r[t] = e[o];else {
        for (var i = 0; void 0 === e[o[i]] && i + 1 < o.length;) i++;
        r[t] = e[o[i]];
      }
      return r;
    }, Object.create(null));
  }
  return _inherits(BabelRegExp, RegExp), BabelRegExp.prototype.exec = function (r) {
    var t = e.exec.call(this, r);
    if (t) {
      t.groups = buildGroups(t, this);
      var p = t.indices;
      p && (p.groups = buildGroups(p, this));
    }
    return t;
  }, BabelRegExp.prototype[Symbol.replace] = function (t, p) {
    if ("string" == typeof p) {
      var o = r.get(this);
      return e[Symbol.replace].call(this, t, p.replace(/\$<([^>]+)>/g, function (e, r) {
        var t = o[r];
        return "$" + (Array.isArray(t) ? t.join("$") : t);
      }));
    }
    if ("function" == typeof p) {
      var i = this;
      return e[Symbol.replace].call(this, t, function () {
        var e = arguments;
        return "object" != typeof e[e.length - 1] && (e = [].slice.call(e)).push(buildGroups(e, i)), p.apply(this, e);
      });
    }
    return e[Symbol.replace].call(this, t, p);
  }, _wrapRegExp.apply(this, arguments);
}
const hygraphRegex = /*#__PURE__*/_wrapRegExp(/https:\/\/([a-z0-9-]+)\.graphassets\.com\/([a-z0-9]+)(?:\/(.*?))?\/([a-z0-9]+)$/, {
  region: 1,
  envId: 2,
  transformations: 3,
  handle: 4
});
export const parse = url => {
  var _transformations$resi, _transformations$resi2, _transformations$outp, _transformations$outp2;
  const base = url.toString();
  const matches = base.match(hygraphRegex);
  if (!(matches !== null && matches !== void 0 && matches.length)) {
    throw new Error("Invalid Hygraph URL");
  }
  const group = matches.groups || {};
  const {
      transformations: unparsedTransformations
    } = group,
    params = _objectWithoutPropertiesLoose(group, _excluded);
  const transformations = parseTransformations(unparsedTransformations || "");
  return {
    base,
    width: Number((_transformations$resi = transformations.resize) === null || _transformations$resi === void 0 ? void 0 : _transformations$resi.width) || undefined,
    height: Number((_transformations$resi2 = transformations.resize) === null || _transformations$resi2 === void 0 ? void 0 : _transformations$resi2.height) || undefined,
    format: transformations.auto_image ? "auto" : ((_transformations$outp = transformations.output) === null || _transformations$outp === void 0 ? void 0 : (_transformations$outp2 = _transformations$outp.format) === null || _transformations$outp2 === void 0 ? void 0 : _transformations$outp2.toString()) || undefined,
    params: Object.assign({
      transformations
    }, params),
    cdn: "hygraph"
  };
};
export const generate = _ref => {
  let {
    base,
    width,
    height,
    format,
    params
  } = _ref;
  const parsed = parse(base.toString());
  const props = Object.assign({
    transformations: {}
  }, parsed.params, params);
  if (width || height) {
    var _props$transformation;
    (_props$transformation = props.transformations).resize || (_props$transformation.resize = {});
  }
  if (width && height) {
    var _props$transformation2;
    (_props$transformation2 = props.transformations.resize).fit || (_props$transformation2.fit = "crop");
  }
  if (width) {
    props.transformations.resize.width = width;
  }
  if (height) {
    props.transformations.resize.height = height;
  }
  if (format === "auto") {
    props.transformations.auto_image = {};
  } else if (format) {
    var _props$transformation3;
    (_props$transformation3 = props.transformations).output || (_props$transformation3.output = {});
    props.transformations.output.format = format;
  }
  const url = new URL(base);
  url.pathname = "/" + props.envId + "/" + formatTransformations(props.transformations) + "/" + props.handle;
  return url.toString();
};
export const transform = _ref2 => {
  let {
    url: originalUrl,
    width,
    height,
    format = "auto"
  } = _ref2;
  const parsed = parse(originalUrl);
  if (!parsed) {
    throw new Error("Invalid Hygraph URL");
  }
  const props = Object.assign({}, parsed, {
    width,
    height,
    format
  });
  return generate(props);
};
const parseTransformations = transformations => {
  if (!transformations) {
    return {};
  }
  return transformations.split("/").reduce((result, part) => {
    const [operation, params] = part.split("=");
    if (params) {
      result[operation] = params.split(",").reduce((obj, param) => {
        const [key, value] = param.split(":");
        obj[key] = isNaN(Number(value)) ? value : Number(value);
        return obj;
      }, {});
    } else {
      result[operation] = {};
    }
    return result;
  }, {});
};
const formatTransformations = transformations => {
  return Object.entries(transformations).filter(_ref3 => {
    let [key, value] = _ref3;
    return Boolean(key) && value !== undefined;
  }).map(_ref4 => {
    let [key, value] = _ref4;
    return Object.keys(value).length === 0 ? key : key + "=" + Object.entries(value).map(_ref5 => {
      let [key, value] = _ref5;
      return key + ":" + value;
    }).join(",");
  }).join("/");
};